export type ProjectOverviewTab = 'dashboard' | 'indicators'

export interface ProjectOverviewNavigationItem {
  id: ProjectOverviewTab
  icon: string
  path: string
  translationKey: string
}

export const PROJECT_OVERVIEW_NAVIGATION: ProjectOverviewNavigationItem[] = [
  {
    id: 'dashboard',
    icon: 'icon-dashboard',
    path: '/',
    translationKey: 'NAVIGATION:ProjectDashboard',
  },
  {
    id: 'indicators',
    icon: 'icon-indicadores',
    path: '/indicators/dashboard',
    translationKey: 'NAVIGATION:Indicators',
  },
]
